const state = () => ({
    lang: "en", //语言
    country: "in", //国家
    device: null,
    bgm: 0,
    sfx: 0,
    notice: 0,
    channel: "ICWVVSYS",
    username: "",
    firbaseUpload: {
        token: "",
        uuid: "",
        date: "",
        uid: 0
    },
    tempUserName: "",
    tempPass: ""
})

// getters
const getters = {
    getChannel: state => {
        let cn = state.channel;
        if (!cn) cn = "ICWVVSYS";
        return cn;
    },
    firbaseUpload: state => { return state.firbaseUpload; },
    getCountry: state => { return state.country; }
}

// actions
const actions = {
    checkUploadFirebaseToken: (context, data) => {
        let storeFirebase = context.getters["firbaseUpload"];
        let isUpload = false;
        //如果这两个参数不相同，则必定上传
        let isSame = (storeFirebase.token == data.token) && (storeFirebase.uuid == data.uuid);
        if (isSame) {
            //uid 不相同并且 data.uid ， 则必定上传
            if (data.uid != storeFirebase.uid && data.uid > 0) {
                isUpload = true;
            } else {
                //比较日期确认是否上传
                let now = (new Date()).getMonth() + "-" + (new Date()).getDate();
                if (storeFirebase.firbaseUpload.date != now) {
                    isUpload = true;
                }
            }
        } else {
            isUpload = true;
        }
        if (isUpload) {
            context.commit("setFirbaseUpload", data);
        }
        return isUpload;
    }
}

// mutations
const mutations = {
    setTempUserName(state, data) {
        state.tempUserName = data;
    },
    setTempPass(state, data) {
        state.tempPass = data;
    },
    setUserName(state, data) {
        state.username = data;
    },
    setFirbaseUpload(state, data) {
        state.firbaseUpload.token = data.token;
        state.firbaseUpload.uuid = data.uuid;
        state.firbaseUpload.uid = data.uid;
        state.firbaseUpload.date = (new Date()).getMonth() + "-" + (new Date()).getDate();
        console.log(state.firbaseUpload);
    },
    setChannel(state, data) {
        state.channel = data;
    },
    setDevice(state, data) {
        state.device = data;
    },
    setLanguage(state, lang) {
        !lang && (lang = "en");
        state.lang = lang;
    },
    setBgm(state, bgm) {
        state.bgm = bgm;
    },
    setSfx(state, sfx) {
        state.sfx = sfx;
    },
    setNotice(state, notice) {
        state.notice = notice;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/common.js